var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClubbieLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 104,
    viewBox: "0 0 98 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0465 65.853V72.6813C77.0465 75.9279 74.4074 78.567 71.1399 78.5879H32.8514C29.6048 78.5879 26.9656 75.9488 26.9447 72.6813V33.8063C26.9447 30.6645 29.4791 28.13 32.6209 28.1091H71.0351C74.3026 28.1091 76.9418 30.7692 76.9418 34.0158V39.3359L97.4266 26.9571C88.5247 10.3263 71.1817 -0.0417647 52.3098 0.000126466C23.74 0.000126466 0.595164 23.124 0.574219 51.6729C0.574219 80.2427 23.6981 103.388 52.2469 103.408C70.9932 103.408 88.2733 93.2918 97.4266 76.9123L77.0675 65.8111L77.0465 65.853Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClubbieLogoWhite);
export default __webpack_public_path__ + "static/media/clubbie_logo_white.b84b4139f90e3d4b055ddc4d490dc226.svg";
export { ForwardRef as ReactComponent };